import PocketBase from 'pocketbase';
import { state, ui } from './stores';
import { get } from 'svelte/store';
import { getCompressedState, getDecompressedState, myUpdaterID, netLog, pushUpdate, queueJob, refreshSync, sendQueue, updateGame } from './sb';
import { flashIndicator } from './ui';
import { resetContinuationBaseline } from './continuation.js';

// Just tried switching to a new server!
const PB_URL = 'https://hutchies.cc/'; //'https://hutchies.pockethost.io/'; // 'http://127.0.0.1:8090';
const PB_USER = 'test@test.com'; // Soon make this individual by username
const PB_PWD = 'testpassword';

export let pb;
let pb_auth_data;
let adminID = 'e4t1w5v7m3oo0yb'; //'rb69qx8d3y1djr7';

pb = new PocketBase(PB_URL);
pb.collection('users').authWithPassword(PB_USER, PB_PWD).then((d) => {
    pb_auth_data = d;
    console.log(pb.authStore.isValid);
    console.log(pb.authStore.token);
    console.log(pb.authStore.record.id);
}).catch(e => {
    console.log('Error with original login', e, e.originalError);
})

//pb.autoCancellation(false); // Could reenable later

export async function adminLogin(){
    if(pb.authStore && pb.authStore.isValid) pb.authStore.clear();
    await pb.collection('users').authWithPassword(PB_USER, PB_PWD);
}

export function amAdmin(){
    return pb.authStore && pb.authStore.record && pb.authStore.record.id == adminID;
}

export async function PBLogin(username){
    if(pb.authStore && pb.authStore.record && pb.authStore.record.email == `${username}@stcc.com`) return;
    //if(pb.authStore && pb.authStore.isValid) pb.authStore.clear();
    if(pb.authStore && pb.authStore.isValid) pb.authStore.clear();
    try{
        let d = await pb.collection('users').authWithPassword(`${username}@stcc.com`, '12345678');
        console.log('login attempt:', d, pb.authStore);
    }catch(e){
        console.log('Error logging in:', e)
        // Presume this is that it needs creating
        await adminLogin();
        try{
            await pb.collection('users').create({
                email: `${username}@stcc.com`,
                password: '12345678',
                passwordConfirm: '12345678'
            });
            if(pb.authStore && pb.authStore.isValid) pb.authStore.clear();
            let d = await pb.collection('users').authWithPassword(`${username}@stcc.com`, '12345678');
            console.log('login attempt:', d, pb.authStore);
        }catch(e){
            //alert('Unable to create user: '+e.message);
            console.log('Unable to create user:', e)
        }
    }
    if(pb.authStore && pb.authStore.record && pb.authStore.record.email != `${username}@stcc.com`){
        console.log("Failed auth login!", pb.authStore);
    };
    if(pb.authStore && pb.authStore.isValid) return true;
}

export async function addDBItem(db, item){
    let updatedString = Object.keys(item).join(',');
    item.thingsUpdated = updatedString;
    try{

        let success = await pb.collection(db).create(item);
        return {success, error: false};
    }catch(error){
        return {error};
    }
}

export async function deleteItem(db, itemTag, itemVal){
    try{
        if(itemTag == 'id'){
            await pb.collection(db).delete(itemVal);
        }else{
            let record = await pb.collection(db).getFirstListItem(`${itemTag}="${itemVal}"`);
            //console.log(record);
            // update
            await pb.collection(db).delete(record.id)
        }
        
        return {success: true, error: false};
    }catch(error){
        return {error};
    }
}

let callCount = 0;

export async function updateItem(db, id, toUpdate, flagUpdated = true, options = undefined){
    let updatedString = Object.keys(toUpdate).join(',')
    toUpdate.thingsUpdated = updatedString;
    try{
        
        //if(itemTag == 'nanoid'){
        console.log(`[db] pb update attempt]: auth valid=${pb.authStore.isValid}, payload size (b): ${JSON.stringify(toUpdate).length}`, toUpdate);
            await pb.collection(db).update(id, toUpdate, options);
            //console.log('call count:', ++callCount);
        //}else{
        //    let record = await pb.collection(db).getFirstListItem(`${itemTag}="${itemVal}"`);
            //console.log(record);
            // update
        //    await pb.collection(db).update(record.id, toUpdate);
        //}
        console.log('successfully updated', toUpdate);
        return {success: true, error: false};
    }catch(error){
        console.log('error updating!', error);
        return {error};
    }
}

// `fields` matters: without it getFullList pulls state_compressed, res_compressed
// and pastMessages for every live game on the server just to draw a lobby table.
export async function getItems(db, filter = false, sort = false, fields = false){
    try{
        let options = {};
        if(filter){
            options.filter = `${filter.column}="${filter.eq}"`;
        }
        if(sort){
            options.sort = `${sort.desc ? '-' : '+'}${sort.column}`
        }
        if(fields){
            options.fields = Array.isArray(fields) ? fields.join(',') : fields;
        }
        let list = await pb.collection(db).getFullList(options);
        return {data: list, error: false};
    }catch(error){
        return {error};
    }
}


let subscriptions = {

};

export function subscribeTable(table, func) {
    try{
        pb.collection(table).subscribe('*', func);
        console.log('subscribed to table ', table)
    }catch(error){
        console.log('error subscribing', error);
        return {error};
    }
}

export function unsubscribeTable(table){
    try{
        pb.collection(table).unsubscribe('*');
        console.log('unsubscribed from table ', table)
    }catch(error){
        console.log('error unsubscribing', error);
        return {error};
    }
}

export async function unsubscribeDB(table, tagName, tagVal){
    try{
        let record = await pb.collection(table).getFirstListItem(`${tagName}="${tagVal}"`);
        pb.collection(table).unsubscribe(record.id);
        netLog({text:`Unsubscribed from ${table}`, data: {table, tagName, tagVal}})
    }catch(error){
        console.log('error unsubscribing', error);
        netLog({text:`Error unsubbing from ${table}`, data: {error, table, tagName, tagVal}})
        return {error};
    }
}

export async function subscribeDB(table, tagName, tagVal, func){
    try{
        let record = await pb.collection(table).getFirstListItem(`${tagName}="${tagVal}"`);
        let unsubscribe = await pb.collection(table).subscribe(record.id, (e) => {
            let newThings = {};
            let oldThings = {};
            // A record touched outside the app (or by an older client) may have no
            // thingsUpdated at all; treat that as "everything is new".
            let updated = e.record.thingsUpdated ? e.record.thingsUpdated.split(',') : Object.keys(e.record);
            for(let k of Object.keys(e.record)){
                if(updated.includes(k)){
                    newThings[k] = e.record[k];
                }else{
                    oldThings[k] = e.record[k];
                }
            }
            let payload = {
                new: newThings,
                old: oldThings
            };
            func(payload);
        })
        console.log('subscribed to updates');
        netLog({text:`Subscribed to ${table}`, data: {table, tagName, tagVal}})
        // NB pb_hooks/selective_broadcast.pb.js publishes to `game <nanoid>`, which
        // is not this topic, so it never fires and PocketBase's own full-record
        // broadcast is what arrives. Switching to that topic would stop our own
        // writes being echoed back to us, but it is a coordinated server deploy.
        return {unsubscribe, error: false};
    }catch(error){
        console.log('error subscribing', error);
        netLog({text:`Error subscribing to ${table}`, data: {error, table, tagName, tagVal}})
        return {error};
    }
}

export async function getGame(db, id){
    //console.log('call count:', ++callCount);
    return await pb.collection(db).getFirstListItem(`nanoid="${id}"`); // Make agnostic later if needs be
}

export async function getItem(db, id){
    try{
        return await pb.collection(db).getFirstListItem(`nanoid="${id}"`); // Make agnostic later if needs be
    }catch(error){
        return {error};
    }
    
}

// Just the mailbox columns — not the whole row, which carries the state blob.
async function fetchMailbox(db, id){
    try{
        return await pb.collection(db).getFirstListItem(`nanoid="${id}"`, {
            fields: 'currentMessage,pastMessages'
        });
    }catch(error){
        console.log('Unable to read messages', error);
        return false;
    }
}

// These used to short-circuit on local state unconditionally and so could never
// re-read the server. Resume decisions ("did I already send this offer?") must be
// able to ask, or they answer from a snapshot that may be arbitrarily stale.
export async function currentMessage(db, id, fresh = false){
    if(!fresh && Object.prototype.hasOwnProperty.call(get(state), 'currentMessage')) return get(state).currentMessage;
    let game = await fetchMailbox(db, id);
    if(game) return game.currentMessage;
    return '';
}

export async function pastMessages(db, id, fresh = false){
    if(!fresh && get(state).pastMessages) return get(state).pastMessages;

    let game = await fetchMailbox(db, id);
    if(game && game.pastMessages) return getDecompressedState(game.pastMessages);
    return [];
}

export async function rollbackMessages(db, id, nanoid, num){
    // deletes any messages back to the given number
    let c = await currentMessage(db, nanoid);
    if(c && c.offerNum >= num) c = '';
    let past = await pastMessages(db, nanoid);
    past = past.filter(p => p.offerNum < num);

    state.update(s => {
        s.currentMessage = c;
        s.pastMessages = past;
        return s;
    })

    // Through pushUpdate for its retry, timeout and "not saved" badge: a lost
    // mailbox write leaves both players waiting on each other.
    queueJob(sendQueue, 'roll back messages', async () => {
        await pushUpdate(id, {currentMessage: c, pastMessages: getCompressedState(past), updatedBy: myUpdaterID()});
    });
    
}

export async function sendMessage(db, id, message){
    //await sendUpdate(false, false); // So state is up to date

    // First, push any existing message to past
    let messages = await pastMessages(db, id);
    if(!messages) messages = [];
    let current = await currentMessage(db, id);
    if(current) messages = [current, ...messages]; // Most recent at front
    state.update(s => {
        s.pastMessages = messages;
        s.currentMessage = message;
        return s;
    })

    //PROBLEM: UPDATEDBY is not being updated maybe??
    if(get(ui).canSave && !Array.isArray(get(state).workingLog) && !get(ui).catchingUp){
        console.log('sending state-based message', message);
        resetContinuationBaseline('message');

        updateGame(get(state), [], get(ui), 'all', {currentMessage: message, pastMessages: getCompressedState(messages)});
    }else{
        console.log('sending changelist-based message', message);
        updateGame(get(state), get(state).choices.thisTurn, get(ui), ['changelist', 'changediffs_compressed'], {currentMessage: message, pastMessages: getCompressedState(messages)});
    }
    // Below a test...
    //console.log('[db] ')
    //await sendQueue.onIdle(); // added so queue can't get cleared until this is done
    
}

export async function closeMessage(db, nanoid, id){

    let messages = await pastMessages(db, nanoid);
    if(!messages) messages = [];
    let current = await currentMessage(db, nanoid);
    if(current) messages = [current, ...messages]; // Most recent at front
    state.update(s => {
        s.currentMessage = '';
        s.pastMessages = messages;
        return s;
    })
    /*console.log('closing messages immediately');
    let response = await updateItem(db, id, {currentMessage: '', pastMessages: getCompressedState(messages)});
    if(response.error && response.status != 0){ // 0 == autocancelled so ignore
        console.log('Error closing messages', response.error);
    }else{
        console.log('[db] closed messages');
        flashIndicator('output');
    }
    return;*/
    // Below is old queue code
    console.log('[db] queueing message closure');
    queueJob(sendQueue, 'close message', async () => {
        await pushUpdate(id, {currentMessage: '', pastMessages: getCompressedState(messages), updatedBy: myUpdaterID()});
    });

}
